import type { SetNameResult } from "./ProfileService";

/** Human messages for a rejected display-name change (Foundations F2): the settings menu's name field and the name
 *  prompt say the same things. */
export const NAME_ERROR_HINTS: Record<Exclude<SetNameResult, { ok: true }>["reason"], string> = {
  too_short: "name too short (min 2)",
  too_long: "name too long (max 24)",
  charset: "use letters, numbers, space, _ . -",
  format: "must start and end with a letter or number",
  profanity: "name not allowed",
  taken: "name already taken",
  error: "couldn't save — try again",
};
